import { combineReducers } from 'redux'
import ClinicPricesByserviceReducer from './clinic.prices.byservice.reducer'

const ClinicPricesReducer = combineReducers({
  byservice: ClinicPricesByserviceReducer,
})

export default ClinicPricesReducer